module.exports = __webpack_public_path__ + "img/code-edit.e1639bb8.svg";